import EnquiryType from '@/enums/EnquiryType';
import ExtraData from '../ExtraData';
import IEnquiryBase from '../interfaces/IEnquiryBase';
import IVehicle from '../vehicle/interfaces/vehicle.d';

export default class EnquiryBase implements IEnquiryBase {
  public enquiryId: number = 0;

  public enquiryReferenceCode!: string; // Note if this breaks on thanks page, set to empty string due to vuex issues
  
  public enquiryDate: Date = new Date();

  public optInMarketing: boolean = false;

  public leadSource: string = '';

  public enquiryType: EnquiryType = EnquiryType.NotSet;

  public title: string | null = null;

  public firstName: string = '';

  public surname: string = '';

  public email: string = '';

  public telephone: string = '';

  public refererUrl!: string;

  public extraData: ExtraData[] = [];

  public vehicles: IVehicle[] = [];

  public privacyPolicyVersionId!: string;

  public termsPolicyVersionId!: string;

  public servicePolicyVersionId!: string;

  public marketingPolicyVersionId!: string;

  public partnerMarketingPolicyVersionId!: string;

  public fCAPolicyVersionId!: string;
}
